import { useId } from "react";
import svgPaths from "../imports/svg-e13exjj5v6";

type ArrowDirection =
  | "left"
  | "right"
  | "left-top"
  | "right-top"
  | "left-bottom"
  | "right-bottom";

interface BurgerArrowProps {
  direction: ArrowDirection;
  color?: string;
  className?: string;
}

export default function BurgerArrow({
  direction,
  color = "#BA4643",
  className = "",
}: BurgerArrowProps) {
  const maskId = useId();

  const config = (() => {
    switch (direction) {
      case "left":
      case "left-top":
        return {
          pathData: svgPaths.p3cc53c80,
          viewBox: "6 6 46 16",
          widthClass: "w-[28px] sm:w-[28px] md:w-[34px] lg:w-[40px]",
          nudgeClass: "-mr-1"
        };

      case "right":
      case "right-top":
        return {
          pathData: svgPaths.p8723e00,
          viewBox: "24 6 46 16",
         widthClass: "w-[28px] sm:w-[28px] md:w-[34px] lg:w-[40px]",
          nudgeClass: "-ml-1"
        };

      case "left-bottom":
        return {
          pathData: svgPaths.p34890500,
          viewBox: "6 9 46 16",
          widthClass: "w-[28px] sm:w-[28px] md:w-[34px] lg:w-[40px]",
          nudgeClass: "-mr-1"
        };

      case "right-bottom":
        return {
          pathData: svgPaths.p100005f2,
          viewBox: "24 9 46 16",
          widthClass: "w-[28px] sm:w-[28px] md:w-[34px] lg:w-[40px]",
          nudgeClass: "-ml-1"
        };

      default:
        return {
          pathData: svgPaths.p3cc53c80,
          viewBox: "6 6 46 16",
          widthClass: "w-[28px] sm:w-[28px] md:w-[34px] lg:w-[40px]",
          nudgeClass: "",
        };
    }
  })();

  return (
    <svg
      className={[
        "block h-auto shrink-0 overflow-visible",
        config.widthClass,
        config.nudgeClass,
        className,
      ].join(" ")}
      fill="none"
      viewBox={config.viewBox}
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
    >
      <defs>
        <mask id={maskId} fill="white">
          <path d={config.pathData} />
        </mask>
      </defs>

      <path d={config.pathData} fill="#F2F1DE" />
      <path d={config.pathData} fill={color} />
      <path d={config.pathData} mask={`url(#${maskId})`} stroke="#F2F1DE" strokeWidth="2" />
      <path d={config.pathData} mask={`url(#${maskId})`} stroke={color} strokeWidth="2" />
    </svg>
  );
}